import { render, staticRenderFns } from "./DiamondModal.vue?vue&type=template&id=06c3e593"
import script from "./DiamondModal.vue?vue&type=script&lang=js"
export * from "./DiamondModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports